import React from "react";
import { InputRangeRow } from "./index";
// Used by the Gilbos Doubler machine

export default function SpindleSpeedRow() {
   return (
      <InputRangeRow
         titleProp={"Spindle Speed"}
         descriptionProp={"meters/min"}
         sizeProp={4}
         typeProp={"text"}
         minProp={1}
         maxProp={999}
         propertyNameProp={"spindleSpeed"}
         errorDialogueProp={"1-999 only"}
         floatProp={false}
      />
   );
}
